var Accordion = (function($) {

  var _s = {
    accordion: $('.chm-block-accordion'),
    accordion_item: $('.chm-block-accordion .accordion-item'),
    accordion_item_title: $('.chm-block-accordion .accordion-item .title'),
    accordion_item_content: $('.chm-block-accordion .accordion-item .content'),
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {
    _s.accordion_item_title.on('click', function() {
      $(this).parent().toggleClass('active');
      $(this).siblings().slideToggle('fast');

      $(this).parent().siblings('.active').removeClass('active');
      $(this).parent().siblings().find('.content').slideUp('fast');

      // GTM Tracking
      if ( $(this).parent().hasClass('active') ) {
        dataLayer.push({
          'event': 'faq_click',
          'engagement_type': 'click'
        });
      }
    });
  };

  return {
    init: _init
  };

})(jQuery);